export const requestedVideoDurations = [
    {
        'value': 10,
        'text': '10s'
    },
    {
        'value': 20,
        'text': '20s'
    },
    {
        'value': 30,
        'text': '30s'
    },
    {
        'value': 40,
        'text': '40s'
    },
    {
        'value': 50,
        'text': '50s'
    },
    {
        'value': 60,
        'text': '1m'
    },
    {
        'value': 70,
        'text': '1m 10s'
    },
    {
        'value': 80,
        'text': '1m 20s'
    },
    {
        'value': 90,
        'text': '1m 30s'
    },
    {
        'value': 100,
        'text': '1m 40s'
    },
    {
        'value': 110,
        'text': '1m 50s'
    },
    {
        'value': 120,
        'text': '2m'
    }
]
